<action-box *ngIf="visible" textLeft="{{actionBoxTitle}}" [showHeader]="showHeader">
  <form-decoration
                   [configurationId]="configurationId"
                   [decoration]="formDecoration"
                   [id]="formDecoration.longId"
                   [showTitle]="false"
                   [view]="RequestViews.Summary"></form-decoration>
</action-box>
